let offsetHeight = document.documentElement.scrollHeight * 0.75;
let toTopBtn = document.getElementById('to-top-button');

function onScroll() {
  if (document.body.scrollTop > offsetHeight || document.documentElement.scrollTop > offsetHeight) {
    toTopBtn.style.display = 'block';
    toTopBtn.classList.add('show');
  } else {
    toTopBtn.style.display = 'none';
    toTopBtn.classList.remove('show');
  }
}

if (toTopBtn) {
  document.addEventListener('scroll', onScroll);
}
